"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Theme = void 0;
var transitions_1 = require("./transitions");
var breakpoints_1 = require("./breakpoints");
var colors_1 = require("./colors");
var link_1 = require("./link");
var palette_1 = require("./palette");
var shadows_1 = require("./shadows");
var shape_1 = require("./shape");
var spacing_1 = require("./spacing");
var typography_1 = require("./typography");
var zIndex_1 = require("./zIndex");
// when adding more, consider what material and ant have done:
// https://material-ui.com/customization/default-theme/
// https://github.com/ant-design/ant-design/blob/master/components/style/themes/default.less
exports.Theme = {
    transitions: transitions_1.transitions,
    breakpoints: breakpoints_1.breakpoints,
    chartingColor: colors_1.chartingColor,
    color: colors_1.color,
    tagColor: colors_1.tagColor,
    link: link_1.link,
    palette: palette_1.palette,
    shadows: shadows_1.shadows,
    shape: shape_1.shape,
    spacing: spacing_1.spacing,
    typography: typography_1.typography,
    zIndex: zIndex_1.zIndex,
};
//# sourceMappingURL=Theme.js.map